module.exports = __webpack_public_path__ + "img/1200.cad53835.jpg";